import * as React from "react";
import { ITaskTypeCol } from "ui/Scripts/source/models/task/taskTypeCol";

export interface ITaskDynamicFormRichTextProp {
    taskTypeCol: ITaskTypeCol;
}

export const TaskDynamicFormRichText = (props: ITaskDynamicFormRichTextProp) => {
    const col = props.taskTypeCol;
    return (
        col.title
            ? <div className="richText" style={{ width: "100%", overflow: "hidden" }} dangerouslySetInnerHTML={{ __html: col.title }}></div>
            : null
    );
};